export default {
    title: 'Conversation Texto',
    notAuthorized: "Vous n'êtes pas autorisé à envoyer un SMS à ce lead.",
    emptyBodyTooltip: 'Le contenu du sms ne peut pas être vide',

    smsBulk: {
        title: 'Composer un nouveau message SMS',
        recipientsLabel: 'Destinataire',
        recipients: '{count} destinataire sélectionné | {count} destinataires sélectionnés',
        sender: {
            label: 'Expéditeur',
            backupLabel: 'Expéditeur de secours',
            myself: 'Moi-même',
            relativeFields: 'Champs liés au lead',
            specificUser: 'Utilisateur spécifique',
        },
        template: {
            category: 'Catégorie',
            templateLabel: 'Modèle',
        },
        localePreference: {
            label: "Langue d'envoi",
            fr: 'Français',
            en: 'Anglais',
            leadLocale: 'Langue du lead',
        },
        body: {
            bodyTitle: 'Contenu du SMS',
            attributesTitle: 'Attributs',
            attributeSearchPlaceholder: 'Rechercher un attribut',
            attributeSearchEmpty: 'Aucun attribut trouvé.',
            placeholder: 'Tapez votre SMS ici...',
            attributePicker: 'Insérer un attribut',
            loadingTemplate: 'Chargement du modèle...',
            previewTitle: 'Aperçu',
            optOutFooterMention: "Ajouté automatiquement à l'envoi",
            characterCount: '{count} / {max}',
            tabs: {
                fr: {
                    label: 'Français',
                    subLabel: 'Français',
                },
                en: {
                    label: 'Anglais',
                    subLabel: 'English',
                },
            },
            warnWithTags:
                "Certaines valeurs personnalisées peuvent être plus longues que l'aperçu et dépasser la limite.",
            warnWithoutTags: 'Le message est proche de la limite maximale.',
            tooLong: 'Le message est trop long.',
        },
        footer: {
            cancel: 'Annuler',
            send: 'Envoyer',
            review: 'Réviser la campagne',
        },
        notifications: {
            sendQueued: "Vos SMS sont en cours d'envoi.",
            sendFailed: "L'envoi SMS en masse n'a pas pu être envoyé. Veuillez réessayer.",
        },
        validation: {
            noSender: 'Veuillez sélectionner un expéditeur.',
            noSenderBackup: 'Veuillez sélectionner un expéditeur de secours.',
            noRecipients: 'Aucun destinataire sélectionné.',
            emptyBody: 'Le message est vide.',
            bodyTooLong: 'Le message dépasse la limite de {max} caractères.',
            missingLocaleTitle: 'Contenu de langue manquant',
            missingLocaleMessage:
                "Le contenu {locale} est vide. Les leads dans cette langue recevront le contenu de l'autre langue. Continuer ?",
            missingLocaleConfirm: 'Envoyer quand même',
        },
    },
};
